var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"cover-back-contour","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Задник_Контур"}},[_c('rect',{staticClass:"bc-c-3",attrs:{"x":"122.8","y":"16","width":"278.57","height":"398.77"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }